import { registerPlugin } from '@capacitor/core';
const JailbreakRoot = registerPlugin('JailbreakRoot', {
    web: () => import('./web').then(m => new m.JailbreakRootWeb()),
    electron: () => import('./web').then(m => new m.JailbreakRootWeb()),
});
export * from './definitions';
export { JailbreakRoot };
//# sourceMappingURL=index.js.map